const typeUser = {
  PUBLISHER: 1,
  OPERATOR: 2,
};

const getStringTypeUser = () => {
  let data = {};
  data[typeUser.PUBLISHER] = "نمایش دهنده";
  data[typeUser.OPERATOR] = "اپراتور هایلات";
  return data;
};

const statusMessage = {
  REJECT_FROM_PUBLISHER: 1,
  REJECT_FROM_OPERATOR: 2,
  SEND_SUGGESTION_TO_PUBLISHER: 3,
};

const getStringStatusMessage = () => {
  let data = {};
  data[statusMessage.REJECT_FROM_OPERATOR] = "رد شده از طرف اپراتور هایلات";
  data[statusMessage.REJECT_FROM_PUBLISHER] = "رد شده از طرف نمایش دهنده";
  data[statusMessage.SEND_SUGGESTION_TO_PUBLISHER] =
    "ارسال پیشنهاد از طرف اپراتور هایلات ";

  return data;
};

module.exports = {
  typeUser,
  getStringTypeUser,
  statusMessage,
  getStringStatusMessage,
};
